<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="resetPasswordForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group row mt-0">
            <div class="col-lg-12 custom-form-main-label">
              {{$t('reset_password')}}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('password')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="password" type="text" class="form-control" v-bind:placeholder="$t('password')" name="password" id="password">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('confirm_password')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <!--<input required v-model="email" type="text" class="form-control" @change="checkForComma" v-bind:placeholder="$t('email')" name="email" id="email">-->
              <input v-model="confirmpassword" type="text" class="form-control" v-bind:placeholder="$t('confirmpassword')" name="confirmpassword" id="confirmpassword">
            </div>
          </div>
          
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="resetpassword" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i>{{$t('save')}}</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>


  let message = "";
  var placeholder = "";


  export default {
    name: "reset-password",
    props: {
      username: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        placeholder,
        password : "",
        confirmpassword : "",
      };
    },
    methods: {
      clearFields() {
        this.password = '';
        this.confirmpassword = '';
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },
      async resetpassword() {
        if (!$('#resetPasswordForm').valid())
          return false;

        var request = {
          confirmPassword: this.confirmpassword, newPassword: this.password,
          username: this.username
        };
        try {
          var response = await this.$http.patch(
            '/api/Users/v1/password',
            request
          ).then(async response => {
            this.clearFields();
            //this.$emit('event-refresh-userlist');
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      }
    },
    watch: {
    },
    mounted() {
      var rules = {
        'password': {
          required: true,
          pwcheck: true,
          minlength: 8,

        },
        'confirmpassword': {
          required: true,
          equalTo: '#password'
        }
      };
      $.validator.addMethod("pwcheck", function (value) {
        //var patt = new RegExp("e");
        var regex = /^.{8,}$////^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
        return regex.test(value.trim());
      });
      var messages = {
        'password': {
          required: 'Required',
          pwcheck: 'Password must be at least 8 characters long.',
          minlength: 'Password must be at least 8 characters long.'
        },

        'confirmpassword': {
          required: 'Required',
          minlength: 'Password must be at least 8 characters long.',
          equalTo: 'Please enter the same password as above.'
        }
      };
      _componentValidation('#resetPasswordForm', rules, messages);

    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100% - 50px)
  }
</style>




// WEBPACK FOOTER //
// src/components/user/reset-password.vue